import React, { PropsWithChildren, ReactNode } from 'react'
import {
    StyledBulletCircle,
    StyledBulletContainer,
    StyledDate,
    StyledDescription,
    StyledLatestLiveBlogMilestonesContainer,
    StyledParentContainer,
    StyledRow,
    StyledTextContainer,
    StyledTitle,
    StyledVerticalLine,
} from './TNLiveBlogMilestones.styled'
import { getReadableTimeSince } from '../../../__helpers'
import { format } from 'date-fns'
import { LatestLiveBlogContent } from '../content-selector-helper'

export type GetLinkWithChildrenComponent = (
    props: PropsWithChildren<{ to: string; key: string }>,
) => ReactNode

export interface LatestLiveBlogMilestonesProps {
    posts: LatestLiveBlogContent[]
    getLinkComponentWithChildren?: GetLinkWithChildrenComponent
    showHeader?: boolean
    showDateTime?: boolean
}

export const TNLiveBlogMilestones = ({
    posts,
    getLinkComponentWithChildren,
    showHeader = false,
    showDateTime = false,
}: LatestLiveBlogMilestonesProps) => {
    return (
        <StyledParentContainer>
            <StyledLatestLiveBlogMilestonesContainer>
                {showHeader && <StyledTitle>Key events</StyledTitle>}
                {posts.map((content) => {
                    const RowComponent = (
                        <LiveBlogMilestoneRow
                            key={content.postId}
                            content={content}
                            showDateTime={showDateTime}
                        />
                    )
                    return getLinkComponentWithChildren
                        ? getLinkComponentWithChildren({
                              to: content.link,
                              key: content.postId,
                              children: RowComponent,
                          })
                        : RowComponent
                })}
            </StyledLatestLiveBlogMilestonesContainer>
        </StyledParentContainer>
    )
}

const LiveBlogMilestoneRow = ({
    content,
    showDateTime = false,
}: {
    content: LatestLiveBlogContent
    showDateTime: boolean
}) => {
    const { title, publishedDate } = content

    const publicationDateMessage = getReadableTimeSince({
        publicationDate: publishedDate,
        comparisonDate: new Date().toISOString(),
    })
    const timeOnlyText = format(new Date(publishedDate), 'hh:mm a')

    return (
        <StyledRow>
            {/* Styling for the bullet point at the start of the post */}
            <StyledBulletContainer>
                <StyledBulletCircle />
                <StyledVerticalLine />
            </StyledBulletContainer>
            {/* Styling the content for row */}
            <StyledTextContainer>
                {showDateTime && (
                    <StyledDate>
                        {publicationDateMessage} - {timeOnlyText}
                    </StyledDate>
                )}
                <StyledDescription>{title}</StyledDescription>
            </StyledTextContainer>
        </StyledRow>
    )
}
